"use client";

import {NavDropdownListProps} from "./MobileMenu/MenuTypes";
import NavDropdownSubmenu from "./NavDropdownSubmenu";
import NavDropdownItemWithChildren from "./NavDropdownItemWithChildren";

const NavDropdownItem = ({menuItems, ...props}: NavDropdownListProps) => {
	return (
		<NavDropdownItemWithChildren {...props}>
			<NavDropdownSubmenu menuItems={menuItems} />
		</NavDropdownItemWithChildren>
	);
};

export default NavDropdownItem;
